module.exports = __webpack_public_path__ + "static/media/bgNft.2971b243.png";